const KEY = "ecell_utm";
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function captureUtm() {
  try {
    const q = new URLSearchParams(window.location.search);
    const found = {};
    PARAMS.forEach((k) => {
      const v = q.get(k);
      if (v) found[k] = v.slice(0, 80);
    });
    if (Object.keys(found).length) sessionStorage.setItem(KEY, JSON.stringify(found));
  } catch {
    // sessionStorage unavailable — ignore
  }
  return utmPayload();
}

export function utmPayload() {
  try {
    const u = JSON.parse(sessionStorage.getItem(KEY) || "{}");
    return {
      utm_source: u.utm_source || "",
      utm_medium: u.utm_medium || "",
      utm_campaign: u.utm_campaign || "",
    };
  } catch {
    return { utm_source: "", utm_medium: "", utm_campaign: "" };
  }
}
